export enum LoggiaEnum {
  OUVERTE = "OUVERTE",
  FERMEE = "FERMEE",
}

export const loggiaEnumLabels = {
  [LoggiaEnum.OUVERTE]: "Ouverte",
  [LoggiaEnum.FERMEE]: "Fermée",
}
